import React from "react";
import localeText from "../../../locale";

const ConfimeaHero = () => {
  return (
    <section className="confimea-hero">
      <div className="confimea-container">
        <div className="confimea-hero-inner">
          <div className="confimea-hero-content">
            <span className="confimea-hero-badge">
              <i className="pi pi-circle-fill" style={{ color: "#7EE5C0", fontSize: "8px" }}></i>{" "}
              {localeText("heroBadge")}
            </span>
            <h1>
              {localeText("heroTitle")} <span>{localeText("heroTitleSpan")}</span>
            </h1>
            <p className="confimea-hero-text">
              {localeText("heroText")}
            </p>
            <a href="#form" className="confimea-btn confimea-btn-white">
              {localeText("heroButton")}
              <svg
                className="confimea-btn-icon"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </a>
            <hr className="opacity-20 mt-5 mb-4 hidden md:block" />
            <div className="confimea-hero-stats hidden md:flex">
              <div className="confimea-hero-stat">
                <span className="confimea-hero-stat-value">{localeText("heroStat1Value")}</span>
                <span className="confimea-hero-stat-label">{localeText("heroStat1Label")}</span>
              </div>
              <div className="confimea-hero-stat">
                <span className="confimea-hero-stat-value">{localeText("heroStat2Value")}</span>
                <span className="confimea-hero-stat-label">{localeText("heroStat2Label")}</span>
              </div>
              <div className="confimea-hero-stat">
                <span className="confimea-hero-stat-value">{localeText("heroStat3Value")}</span>
                <span className="confimea-hero-stat-label">{localeText("heroStat3Label")}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ConfimeaHero;
